import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IRegisterState} from "./register.state";

export const registerFeatureSelector = createFeatureSelector<IRegisterState>('register');

export const getServiceRegistrationSelector = createSelector(
    registerFeatureSelector,
    state => state.serviceRegistrationData
);

export const getIsRegisteringSelector = createSelector(
    registerFeatureSelector,
    state => state.isRegistering
);

export const getRegistationResultSelector = createSelector(
    registerFeatureSelector,
    state => state.registrationResult
);

export const getRegistrationError = createSelector(
    registerFeatureSelector,
    state => state.error
);
